module.exports = __webpack_public_path__ + "static/img/sc6.029f6b1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sc6.png
// module id = xAiR
// module chunks = 25